export default __webpack_public_path__ + "static/media/svg-4.b1268ef4.svg";